// extracted by mini-css-extract-plugin
export default {"root":"DatePicker_root__D+nki"};